import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { BaccaratOutcome, BaccaratPhase, CardPosition } from '../models/communication/baccarat-enums.model';

@Component({
    selector: 'app-phase-title',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './phase-title.component.html',
    styleUrl: './phase-title.component.scss'
})
export class PhaseTitleComponent {
    @Input()
    phase!: BaccaratPhase;

    @Input()
    nextCardPosition?: CardPosition;

    @Input()
    outcome?: BaccaratOutcome;

    @Input()
    burnedCount = 0;

    @Input()
    totalToBurnCount = 0;

    @Input()
    winnerHandValue = 0;

    protected readonly BaccaratOutcome = BaccaratOutcome;
    protected readonly BaccaratPhase = BaccaratPhase;
    protected readonly CardPosition = CardPosition;
}
